import type { FC, PropsWithChildren } from "react";
import { glassImageContainer, glassImageHeaderWrapper, linearGradientOverlaySurface } from "./styles";

/**
 * Renders the fullwidth blurred hero image as well as the dark overlay
 * This is the "header" for portal
 */
export const GlassImageWrapper: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={glassImageHeaderWrapper}>
      {children}
      <div className={glassImageContainer} aria-hidden>
        <div className={linearGradientOverlaySurface} />
      </div>
    </div>
  );
};
